<template>
  <span>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="notInAdldsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Warning</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Please note that the user does not exist in AD LDS yet but has been
        disabled in the database.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('notInAdldsModal');
            $router.push('/recruiting');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="errorAdldsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        An error was encountered attempting to disable the user access (AD LDS).
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorAdldsModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="verifyAllModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Warning</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        You have selected ALL agencies and one or more individual agencies.
        Select continue to allow access to ALL agencies.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="continueWithAll">Continue</v-btn>
        <v-btn color="#00558C" dark @click="$modal.hide('verifyAllModal')"
          >Edit</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="userExistsForAOModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        A user already exists with this email. Please verify the user's email.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('userExistsForAOModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="userExistsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        This user is already active with another agency.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('userExistsModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="userExistsForOtherAOModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        This user is already active with another agency.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('userExistsForOtherAOModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="userExistsInAdldsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        The email address entered is already in use.  Please use a different email address.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('userExistsInAdldsModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="cognitoErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        The administrator could not be removed from the authentication system.
        If the administrator is in Pending status, this may indicate the
        administrator was not yet present in the authentication system.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('cognitoErrorModal');
            $router.push('/recruiting');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="inactiveSaveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Warning</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Did you intend to reactivate this administrator? Changes to inactive
        administrators will not be saved.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('inactiveSaveModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="insertUpdateErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Email '{{ form.email }}' is already active for another account.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('insertUpdateErrorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="insertDupErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Email '{{ form.email }}' already exists. Record will not be inserted.
        Please edit the existing admin to make updates.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('insertDupErrorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="saveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Submitted</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Your changes have been submitted for processing. Changes may take up to
        24 hours to go into effect.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('saveModal');
            $router.push('/recruiting');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="noChangesModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>No Updates Detected</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        <br />
        No updates were detected. Please make your edits and re-submit.
        <br />
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('noChangesModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="selectPermissionsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Validation Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Please select at least one permission for the admin user.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('selectPermissionsModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <div ref="form" style="max-width: 1200px; margin: auto; margin-top: 100px">
      <v-card-title>
        <v-row>
          <v-col>
            <h4
              :class="
                $vuetify.breakpoint.smAndUp ? 'addressTitle' : 'addressTitleXS'
              "
            >
              <v-icon color="green" size="36">mdi-lead-pencil</v-icon>&nbsp;

              <span v-if="isUpdate">Update Recruiting User</span>
              <span v-else>Create Recruiting User</span>
            </h4>

            <span
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'addressTitle2'
                  : 'addressTitleXS2'
              "
              >AGENCY OWNER: {{ primaryAOName }}
            </span>
          </v-col>
        </v-row>
        <br /><br />
      </v-card-title>

      <v-card-text v-if="$vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col>
            <v-row class="littleDrop"> </v-row>
            <v-row v-if="isUpdate" class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="federationId"
                  v-model="federationIdLocal"
                  label="Email"
                  outlined
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="isUpdate">
              <v-col>
                <v-text-field
                  ref="status"
                  v-model="statusLocal"
                  label="Recruiter Status"
                  outlined
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  ref="activeStatusDate"
                  :value="activeStatusDateLocal | mmddyyyy"
                  label="Active Status Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  ref="inActiveStatusDate"
                  :value="inActiveStatusDateLocal | mmddyyyy"
                  label="Inactive Status Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-checkbox
                  v-if="
                    user.Status == 'A' ||
                      user.Status == 'P' ||
                      user.Status == 'F'
                  "
                  color="green"
                  label="Disable User Access?"
                  v-model="disableUser"
                  style="margin-top: 0px"
                  :readonly="
                    user.TMKClientID == loggedInTmkClientId ||
                      (!loggedInUserIsAO && roleLocal == 'Recruiting Director')
                  "
                ></v-checkbox>

                <v-checkbox
                  v-else
                  color="green"
                  label="Enable User Access?"
                  v-model="enableUser"
                  style="margin-top: 0px"
                  :readonly="
                    user.TMKClientID == loggedInTmkClientId ||
                      (!loggedInUserIsAO && roleLocal == 'Recruiting Director')
                  "
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="isUpdate">
              <v-col>
                <v-text-field
                  ref="statusMsg"
                  v-model="statusMessageLocal"
                  label="Status Message"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isUpdate">
              <v-col>
                <v-checkbox
                  color="green"
                  label="Re-Activate Salesforce License?"
                  v-model="ActivateSalesforceLicenseIndLocal"
                  style="margin-top: 0px"
                ></v-checkbox> </v-col
              ><v-col>
                <v-text-field
                  ref="lastSalesforceActivatedDate"
                  :value="LastSalesforceActivatedDateLocal | mmddyyyy"
                  label="Last Salesforce License Re-Activation Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="firstName"
                  v-model.trim="firstNameLocal"
                  :rules="[() => !!firstNameLocal || 'First Name is required']"
                  label="*First Name"
                  outlined
                  required
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="middleName"
                  v-model.trim="middleNameLocal"
                  label="Middle Name"
                  outlined
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="lastName"
                  v-model.trim="lastNameLocal"
                  :rules="[() => !!lastNameLocal || 'Last Name is required']"
                  label="*Last Name"
                  outlined
                  required
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="address"
                  v-model.trim="addressLocal"
                  :rules="[
                    () => !!addressLocal || 'Address line one is required'
                  ]"
                  label="*Address"
                  outlined
                  required
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  ref="address2"
                  v-model.trim="address2Local"
                  :rules="[]"
                  label="Address Line 2"
                  outlined
                  required
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="city"
                  v-model.trim="cityLocal"
                  :rules="[() => !!cityLocal || 'City is required']"
                  label="*City"
                  outlined
                  dense
                  required
                  maxLength="100"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  ref="state"
                  v-model="stateLocal"
                  :rules="[() => !!stateLocal || 'State/Province is required']"
                  :items="statesOrProvinces"
                  label="*State"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                  v-if="countryLocal == 'United States of America'"
                ></v-autocomplete>
                <v-text-field
                  v-if="countryLocal != 'United States of America'"
                  ref="state"
                  v-model.trim="stateLocal"
                  :rules="[() => !!stateLocal || 'State/Province is required']"
                  label="*State/Province"
                  outlined
                  dense
                  required
                  maxLength="50"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="zip"
                  v-model.trim="zipLocal"
                  :rules="[
                    () => !!zipLocal || 'ZIP/Postal Code is required',
                    () =>
                      /^((\d{5})|(\d{5}\-\d{4}))$/.test(zipLocal) ||
                      'ZIP/Postal Code must be 5 or 9 digits (99999 or 99999-9999).'
                  ]"
                  label="*ZIP / Postal Code"
                  required
                  outlined
                  dense
                  maxLength="20"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <!-- <v-autocomplete
                  ref="country"
                  v-model="countryLocal"
                  :rules="[() => !!countryLocal || 'Country is required']"                  
                  label="Country"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                ></v-autocomplete> -->
                <v-text-field
                  ref="country"
                  v-model="countryLocal"
                  :rules="[() => !!countryLocal || 'Country is required']"
                  label="*Country"
                  required
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="removeTopAndBottomPadding">
                <v-text-field
                  ref="phone"
                  v-model.trim="phoneLocal"
                  :rules="[
                    () => !!phoneLocal || 'Phone Number is required',
                    () =>
                      !phoneLocal ||
                      /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                        phoneLocal
                      ) ||
                      'Please enter a valid phone number with area code.'
                  ]"
                  label="*Phone Number"
                  outlined
                  required
                  dense
                  maxLength="30"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  v-show="!isUpdate"
                  ref="email"
                  v-model.trim="emailLocal"
                  :rules="[
                    () => !!emailLocal || 'Email is required.',
                    () =>
                      /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
                        emailLocal ? emailLocal.trim() : emailLocal
                      ) || 'Email must be valid'
                  ]"
                  label="*Email Address"
                  outlined
                  required
                  dense
                  maxLength="100"
                ></v-text-field>
              </v-col>
            </v-row>
            <hr />
            <br />
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  ref="role"
                  v-model="roleLocal"
                  @change="onChangeRole"
                  :rules="[() => !!roleLocal || 'Role is required']"
                  :items="filteredRoles"
                  :readonly="isUpdate && !loggedInUserIsAO"
                  label="*Title"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  v-if="roleLocal == 'Recruiter'"
                  :disabled="
                    roleLocal == '' ||
                      roleLocal == undefined ||
                      roleLocal == null
                  "
                  ref="agency"
                  v-model="agencyLocal"
                  :rules="[() => !!agencyLocal || 'Agency is required']"
                  :items="combinedAgencies"
                  label="*Agency Office Number"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                  :readonly="
                    isUpdate &&
                      (user.TMKClientID == loggedInTmkClientId ||
                        (!loggedInUserIsAO &&
                          roleLocal == 'Recruiting Director'))
                  "
                ></v-autocomplete>
                <v-autocomplete
                  v-else
                  :disabled="
                    roleLocal == '' ||
                      roleLocal == undefined ||
                      roleLocal == null
                  "
                  multiple
                  ref="agency"
                  v-model="agencyLocal"
                  :rules="[
                    () => agencyLocal.length > 0 || 'Agency is required'
                  ]"
                  :items="combinedAgencies"
                  label="*Agency Office Number"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                  :readonly="
                    isUpdate &&
                      (user.TMKClientID == loggedInTmkClientId ||
                        (!loggedInUserIsAO &&
                          roleLocal == 'Recruiting Director'))
                  "
                ></v-autocomplete>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  :disabled="agencyLocal == [] || agencyLocal == ''"
                  ref="manager"
                  v-model="managerLocal"
                  :rules="[() => !!managerLocal || 'Manager is required']"
                  :items="computedManagerNames"
                  label="*Manager"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                ></v-autocomplete>

                <!-- @blur="agentNumberValues=agentNumberValues.sort()"
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col>
                <h2 style="color: green">Permissions</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <v-checkbox
                      color="green"
                      label="Agent Hierarchy - Agent Data"
                      v-model="agentData"
                    ></v-checkbox>
                    <v-checkbox
                      color="green"
                      label="My Business - Policy Data"
                      v-model="policyData"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
                <br /><br />
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Case Management</h3>
                    <v-checkbox
                      color="green"
                      label="Add/Update Access"
                      v-model="cmAddUpdate"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="View Access"
                      v-model="cmView"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Agent Tools - Applications</h3>
                    <v-checkbox
                      color="green"
                      label="Agent Appointments"
                      v-model="agentAppointments"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Agent Resources"
                      v-model="agentResources"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Do Not Call Request Form"
                      v-model="doNotCallReq"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Do Not Call Search Form"
                      v-model="doNotCallSearch"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="IGo eAPP"
                      v-model="iGoEApp"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Life Proposal System"
                      v-model="lifeProposalSystem"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Part A Deductible Waiver Program"
                      v-model="partADedWaiverProg"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Reports</h3>
                    <v-checkbox
                      color="green"
                      label="Commission Statements"
                      v-model="commissionStatements"
                    ></v-checkbox>
                    <v-checkbox
                      color="green"
                      label="Danger List"
                      v-model="dangerList"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Pending Rate Increase"
                      v-model="pendingRateIncrease"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Production Report"
                      v-model="productionReport"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="$vuetify.breakpoint.smAndDown">
        <v-row class="littleDrop"> </v-row>

        <v-row v-if="isUpdate" class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="federationId"
              v-model="federationIdLocal"
              label="Email"
              outlined
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="status"
              v-model="statusLocal"
              label="Recruiter Status"
              outlined
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="activeStatusDate"
              :value="activeStatusDateLocal | mmddyyyy"
              label="Active Status Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="inActiveStatusDate"
              :value="inActiveStatusDateLocal | mmddyyyy"
              label="Inactive Status Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-checkbox
              v-if="
                user.Status == 'A' || user.Status == 'P' || user.Status == 'F'
              "
              color="green"
              label="Disable User Access?"
              v-model="disableUser"
              style="margin-top: 0px"
              :readonly="
                user.TMKClientID == loggedInTmkClientId ||
                  (!loggedInUserIsAO && roleLocal == 'Recruiting Director')
              "
            ></v-checkbox>

            <v-checkbox
              v-else
              color="green"
              label="Enable User Access?"
              v-model="enableUser"
              style="margin-top: 0px"
              :readonly="
                user.TMKClientID == loggedInTmkClientId ||
                  (!loggedInUserIsAO && roleLocal == 'Recruiting Director')
              "
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="statusMsg"
              v-model="statusMessageLocal"
              label="Status Message"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-checkbox
              color="green"
              label="Re-Activate Salesforce License?"
              v-model="ActivateSalesforceLicenseIndLocal"
              style="margin-top: 0px"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="lastSalesforceActivatedDate"
              :value="LastSalesforceActivatedDateLocal | mmddyyyy"
              label="Last Salesforce License Re-Activation Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="firstName"
              v-model.trim="firstNameLocal"
              :rules="[() => !!firstNameLocal || 'First Name is required']"
              label="*First Name"
              outlined
              required
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="middleName"
              v-model.trim="middleNameLocal"
              label="Middle Name"
              outlined
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="lastName"
              v-model.trim="lastNameLocal"
              :rules="[() => !!lastNameLocal || 'Last Name is required']"
              label="*Last Name"
              outlined
              required
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="address"
              v-model.trim="addressLocal"
              :rules="[() => !!addressLocal || 'Address line one is required']"
              label="*Address"
              outlined
              required
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              ref="address2"
              v-model.trim="address2Local"
              :rules="[]"
              label="Address Line 2"
              outlined
              required
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="city"
              v-model.trim="cityLocal"
              :rules="[() => !!cityLocal || 'City is required']"
              label="*City"
              outlined
              dense
              required
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              :items="statesOrProvinces"
              label="*State"
              placeholder="Select..."
              required
              outlined
              dense
              v-if="countryLocal == 'United States of America'"
            ></v-autocomplete>
            <v-text-field
              v-if="countryLocal != 'United States of America'"
              ref="state"
              v-model.trim="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              label="*State/Province"
              outlined
              dense
              required
              maxLength="50"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="zip"
              v-model.trim="zipLocal"
              :rules="[
                () => !!zipLocal || 'ZIP/Postal Code is required',
                () =>
                  /^((\d{5})|(\d{5}\-\d{4}))$/.test(zipLocal) ||
                  'ZIP/Postal Code must be 5 or 9 digits (99999 or 99999-9999).'
              ]"
              label="*ZIP / Postal Code"
              required
              outlined
              dense
              maxLength="20"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <!-- <v-autocomplete
              ref="country"
              v-model="countryLocal"
              :rules="[() => !!countryLocal || 'Country is required']"
              label="Country"
              placeholder="Select..."
              required
              outlined
              dense
            ></v-autocomplete> -->
            <v-text-field
              ref="country"
              v-model="countryLocal"
              :rules="[() => !!countryLocal || 'Country is required']"
              label="*Country"
              required
              outlined
              dense
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="phone"
              v-model.trim="phoneLocal"
              :rules="[
                () => !!phoneLocal || 'Phone Number is required',
                () =>
                  !phoneLocal ||
                  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                    phoneLocal
                  ) ||
                  'Please enter a valid phone number with area code.'
              ]"
              label="*Phone Number"
              outlined
              required
              dense
              maxLength="30"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              v-show="!isUpdate"
              ref="email"
              v-model.trim="emailLocal"
              :rules="[
                () => !!emailLocal || 'Email is required.',
                () =>
                  /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
                    emailLocal ? emailLocal.trim() : emailLocal
                  ) || 'Email must be valid'
              ]"
              label="*Email Address"
              outlined
              required
              dense
              maxLength="100"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr />
        <br />
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding ">
            <v-autocomplete
              ref="role"
              v-model="roleLocal"
              @change="onChangeRole"
              :rules="[() => !!roleLocal || 'Role is required']"
              :items="filteredRoles"
              :readonly="isUpdate && !loggedInUserIsAO"
              label="*Title"
              placeholder="Select..."
              required
              outlined
              dense
            ></v-autocomplete>

            <!-- 
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding ">
            <v-autocomplete
              v-if="roleLocal == 'Recruiter'"
              ref="agency"
              v-model="agencyLocal"
              :rules="[() => !!agencyLocal || 'Agency is required']"
              :items="combinedAgencies"
              label="*Agency Office Number"
              placeholder="Select..."
              required
              outlined
              dense
              :readonly="
                isUpdate &&
                  (user.TMKClientID == loggedInTmkClientId ||
                    (!loggedInUserIsAO && roleLocal == 'Recruiting Director'))
              "
            ></v-autocomplete>
            <v-autocomplete
              v-else
              multiple
              ref="agency"
              v-model="agencyLocal"
              :rules="[() => agencyLocal.length > 0 || 'Agency is required']"
              :items="combinedAgencies"
              label="*Agency Office Number"
              placeholder="Select..."
              required
              outlined
              dense
              :readonly="
                isUpdate &&
                  (user.TMKClientID == loggedInTmkClientId ||
                    (!loggedInUserIsAO && roleLocal == 'Recruiting Director'))
              "
            ></v-autocomplete>

            <!-- 
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding ">
            <v-autocomplete
              :disabled="agencyLocal == [] || agencyLocal == ''"
              ref="manager"
              v-model="managerLocal"
              :rules="[() => !!managerLocal || 'Manager is required']"
              :items="computedManagerNames"
              label="*Manager"
              placeholder="Select..."
              required
              outlined
              dense
            ></v-autocomplete>

            <!-- 
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col>
            <h2 style="color: green">Permissions</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <v-checkbox
                  color="green"
                  label="Agent Hierarchy - Agent Data"
                  v-model="agentData"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="My Business - Policy Data"
                  v-model="policyData"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Case Management</h3>
                <v-checkbox
                  color="green"
                  label="Add/Update Access"
                  v-model="cmAddUpdate"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="View Access"
                  v-model="cmView"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Agent Tools - Applications</h3>
                <v-checkbox
                  color="green"
                  label="Agent Appointments"
                  v-model="agentAppointments"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Agent Resources"
                  v-model="agentResources"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Do Not Call Request Form"
                  v-model="doNotCallReq"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Do Not Call Search Form"
                  v-model="doNotCallSearch"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="IGo eAPP"
                  v-model="iGoEApp"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Life Proposal System"
                  v-model="lifeProposalSystem"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Part A Deductible Waiver Program"
                  v-model="partADedWaiverProg"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Reports</h3>
                <v-checkbox
                  color="green"
                  label="Commission Statements"
                  v-model="commissionStatements"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Danger List"
                  v-model="dangerList"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Pending Rate Increase"
                  v-model="pendingRateIncrease"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Production Report"
                  v-model="productionReport"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> -->
      </v-card-text>

      <v-divider class="removeTopAndBottomPadding"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="menuBtn"
          color="#00558c"
          dark
          @click.native="cancelChanges"
          >Cancel</v-btn
        >

        <v-btn
          color="green"
          class="menuBtn"
          dark
          @click="submit(false)"
          v-if="
            haveAgencies == true &&
              havePartnershipAgencies == true &&
              haveManagers == true
          "
          >Submit</v-btn
        >
        <v-btn color="#D3D3D3" class="menuBtn" dark v-else>Submit</v-btn>
      </v-card-actions>
      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <v-overlay :value="waitCircle"></v-overlay>
    </div>
    <br /><br /><br /><br />
  </span>
</template>
<script>
// import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP_GAP, HTTP_LND } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  props: {
    user: Object,
    mode: String,
    primaryAO: Object
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobileCheck);
  },
  created() {
    if (!this.mode) {
      this.$router.push("/recruiting");
    }

    this.isMobileCheck();

    window.addEventListener("resize", this.isMobileCheck);
  },
  mounted() {
    if (this.user && this.user != null) {
      this.federationIdLocal = this.user.FederationID;
      this.firstNameLocal = this.user.FirstName;
      this.middleNameLocal = this.user.MiddleName;
      this.lastNameLocal = this.user.LastName;
      this.addressLocal = this.user.AddressLine1;
      this.address2Local = this.user.AddressLine2;
      this.cityLocal = this.user.City;
      this.stateLocal = this.user.StateProvinceCode;
      this.zipLocal = this.user.PostalCode;
      this.phoneLocal = this.user.PhoneNum;
      this.emailLocal = this.user.Email;

      // test
      // this.countryLocal = this.user.ISOCountryCode;
      this.countryLocal = this.user.ISOCountryCode
        ? this.translateCodeToCountry(this.user.ISOCountryCode)
        : "United States of America";

      if (!this.countryLocal) {
        this.countryLocal = "United States of America";
      } else {
        this.countryLocal = "United States of America";
      }

      this.policyData = true;
      this.agentData = true;
      this.cmView = true;
      this.cmAddUpdate = true;
      this.commissionStatements = true;
      this.productionReport = true;
      this.pendingRateIncrease = true;
      this.dangerList = true;
      this.iGoEApp = true;
      this.agentAppointments = true;
      this.lifeProposalSystem = true;
      this.partADedWaiverProg = true;
      this.doNotCallSearch = true;
      this.doNotCallReq = true;
      this.agentResources = true;

      this.ActivateSalesforceLicenseIndLocal = this.user.ActivateSalesforceLicenseInd;
      this.LastSalesforceActivatedDateLocal = this.user.LastSalesforceLicenseActivatedDate;

      this.statusLocal = this.Status;
      this.statusMessageLocal = this.user.AgentAdminStatusMessageText;
      if (this.user.Status == "A" || this.user.Status == "I") {
        this.activeStatusDateLocal = this.user.EmploymentDate;
        this.inActiveStatusDateLocal = this.user.TerminationDate;
      }

      this.roleLocal = this.user.Role;
      if (this.roleLocal != "Recruiter") {
        this.agencyLocal = [];
      }
    }

    //this.getCountries();
    this.waitCircle = true;
    this.getAgencies();
    this.getPartnershipAgencies();
    this.getManagers();
  },
  data: () => ({
    haveAgencies: false,
    havePartnershipAgencies: false,
    haveManagers: false,
    adldsStatus: "",
    search: "",
    loading: false,
    shiftDown: false,
    allIndicator: true,
    possibleAgentNumberValues: [],
    possibleAgentNumbers: [],
    agentNumberValues: [],
    previousAgentNumberValues: [],
    shiftedAgentNumberValues: [],
    lastClickedAgentNumber: "",
    previousClickedAgentNumber: "",
    previousCountry: null,
    enableUser: false,
    disableUser: false,
    allCountries: [],
    roles: ["Recruiting Director", "Recruiter"],
    agencies: [],
    partnershipAgencies: [],
    managers: [],
    emailRules: [
      v => !!v || "Email is required.",
      v =>
        /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
          v.trim()
        ) || "Email must be valid"
    ],
    waitCircle: false,
    countries: ["United States of America"],
    countriesArray: [],
    provinces: [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland",
      "Labrador",
      "Nova Scotia",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan"
    ],
    states: [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ],
    errorMessages: "",
    federationIdLocal: null,
    firstNameLocal: "",
    middleNameLocal: "",
    lastNameLocal: "",
    addressLocal: "",
    address2Local: "",
    cityLocal: "",
    stateLocal: "",
    zipLocal: "",
    countryLocal: "United States of America",
    phoneLocal: "",
    phoneExtLocal: "",
    emailLocal: "",
    statusLocal: "",
    statusMessageLocal: "",
    activeStatusDateLocal: null,
    inActiveStatusDateLocal: null,
    ActivateSalesforceLicenseIndLocal: null,
    LastSalesforceActivatedDateLocal: null,
    roleLocal: "",
    agencyLocal: "",
    managerLocal: "",
    formHasErrors: false,
    policyData: true,
    agentData: true,
    agentResources: true,
    cmView: true,
    cmAddUpdate: true,
    iGoEApp: true,
    agentAppointments: true,
    lifeProposalSystem: true,
    partADedWaiverProg: true,
    doNotCallReq: true,
    doNotCallSearch: true,
    commissionStatements: true,
    pendingRateIncrease: true,
    productionReport: true,
    dangerList: true
  }),

  computed: {
    filteredRoles() {
      if (this.isUpdate) {
        return this.roles;
      }
      if (this.loggedInUserIsAO) {
        return this.roles;
      } else {
        return ["Recruiter"];
      }
    },
    loggedInUserIsAO() {
      if (this.loggedInTmkClientId == this.primaryAO.TMKClientID) {
        return true;
      } else {
        return false;
      }
    },
    loggedInTmkClientId() {
      return window.sessionStorage.getItem("tmkClientId");
    },
    computedManagerNames() {
      let cm = [];
      if (this.roleLocal == "Recruiting Director") {
        let manager = this.managers.find(
          m => m.AgentNum == this.primaryAO.AgentNum
        );
        if (manager != null) {
          cm.push(
            manager.FirstName.trim() +
              (manager.MiddleName.trim().length > 0
                ? " " + manager.MiddleName.trim()
                : "") +
              " " +
              manager.LastName.trim() +
              " (" +
              this.formatAgentNumber(manager.AgentNum) +
              " - " +
              manager.RoleCode +
              ")"
          );
        }
      } else {
        for (let manager of this.managers) {
          if (this.agencyLocal.length == 0) {
            return [];
          } else {
            if (
              this.agencyLocal != null &&
              this.agencyLocal != undefined &&
              this.agencyLocal != [] &&
              this.agencyLocal.startsWith(manager.AgencyCode + " ")
            ) {
              cm.push(
                manager.FirstName.trim() +
                  (manager.MiddleName.trim().length > 0
                    ? " " + manager.MiddleName.trim()
                    : "") +
                  " " +
                  manager.LastName.trim() +
                  " (" +
                  this.formatAgentNumber(manager.AgentNum) +
                  " - " +
                  manager.RoleCode +
                  ")"
              );
            }
          }
        }
      }

      return cm.sort((a, b) => {
        if (a.toUpperCase() > b.toUpperCase()) return 1;
        if (b.toUpperCase() > a.toUpperCase()) return -1;
        return 0;
      });
    },
    combinedAgencies() {
      let ca = [];
      for (let agency of this.agencies) {
        ca.push(agency.AgencyCode.trim() + " " + agency.AgencyName.trim());
      }
      for (let agency of this.partnershipAgencies) {
        ca.push(agency.AgencyCode.trim() + " " + agency.AgencyName.trim());
      }
      ca = ca.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
      });
      let caModified;
      if (this.roleLocal == "Recruiter") {
        caModified = ca;
      } else {
        caModified = ["ALL"];
        caModified.push(...ca);
      }
      return caModified;
    },
    primaryAOName() {
      if (this.primaryAO == null) {
        return "";
      }

      return (
        (this.primaryAO.FirstName + " " + this.primaryAO.MiddleName).trim() +
        " " +
        this.primaryAO.LastName
      ).trim();
    },
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "215";
    },

    Status() {
      switch (this.user.Status) {
        case "A":
          return "Active";
        case "I":
          return "Inactive";
        case "F":
          return "Failed";
        case "P":
          return "Pending";
        default:
          return "Unknown";
      }
    },
    isUpdate() {
      return this.mode == "Update";

      // if (
      //   this.user &&
      //   this.user.FederationID &&
      //   this.user.FederationID.trim() != ""
      // )
      //   return true;
      // return false;
    },
    statesOrProvinces() {
      let sts = this.states;

      return sts.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;

        return 0;
      });
    },

    form() {
      return {
        firstName: this.firstNameLocal,
        middleName: this.middleNameLocal,
        lastName: this.lastNameLocal,
        address: this.addressLocal,
        address2: this.address2Local,
        city: this.cityLocal,
        state: this.stateLocal,
        zip: this.zipLocal,
        country: this.countryLocal,
        phone: this.phoneLocal,
        email: this.emailLocal,
        role: this.roleLocal,
        agency: this.agencyLocal,
        manager: this.managerLocal
      };
    }
  },

  watch: {
    agencyLocal() {
      if (this.roleLocal == "Recruiting Director") {
        this.managerLocal = this.computedManagerNames.find(x => x);
      } else {
        this.$refs.manager.resetValidation();
      }
    },
    roleLocal() {
      if (this.roleLocal == "Recruiting Director") {
        this.managerLocal = this.computedManagerNames.find(x => x);
      } else {
        this.managerLocal = "";
      }
    },
    combinedAgencies() {
      if (this.combinedAgencies.length == 0) {
        return;
      }
      if (this.user && this.user != null) {
        if (this.roleLocal == "Recruiting Director") {
          this.agencyLocal = [];
        }
        this.user.Accesses.forEach(element => {
          let x = this.combinedAgencies.find(cam =>
            cam.startsWith(element.AgencyCode)
          );
          if (x != null) {
            if (this.roleLocal == "Recruiter") {
              this.agencyLocal = x;
            } else if (this.roleLocal == "Recruiting Director") {
              if (element == "ALL") {
                this.agencyLocal = ["ALL"];
              } else {
                this.agencyLocal.push(x);
              }
            }
          }
        });
      }
    },
    computedManagerNames() {
      if (this.computedManagerNames.length == 0) {
        return;
      }
      if (this.user && this.user != null) {
        if (this.roleLocal == "Recruiting Director") {
          this.managerLocal = this.computedManagerNames.find(x => x);
        } else if (this.roleLocal == "Recruiter") {
          this.managerLocal = this.computedManagerNames.find(
            x =>
              x.includes(
                this.formatAgentNumber(this.user.Accesses[0].ManagerAgentNum)
              ) && x.includes(this.user.Accesses[0].ManagerRoleCode)
          );
        }
      }
    },
    agentNumberValues() {
      this.shiftedAgentNumberValues = [];
      this.shiftedAgentNumberValues.push(...this.agentNumberValues);

      if (
        this.agentNumberValues.length > this.previousAgentNumberValues.length
      ) {
        for (let anv of this.agentNumberValues) {
          let found = false;
          for (let panv of this.previousAgentNumberValues) {
            if (anv == panv) {
              found = true;
            }
            if (!found) this.lastClickedAgentNumber = anv;
            if (this.previousClickedAgentNumber == "")
              this.previousClickedAgentNumber = anv;
          }
        }
      } else {
        this.lastClickedAgentNumber = "";
        this.previousClickedAgentNumber = "";
      }

      if (
        this.shiftDown == true &&
        this.agentNumberValues.length > this.previousAgentNumberValues.length
      ) {
        let copy = false;

        for (let pan of this.possibleAgentNumbers) {
          if (copy) {
            if (this.shiftedAgentNumberValues.indexOf(pan.value) < 0)
              this.shiftedAgentNumberValues.push(pan.value);
          }

          if (this.lastClickedAgentNumber > this.previousClickedAgentNumber) {
            if (pan.value == this.previousClickedAgentNumber) {
              copy = true;
            }
            if (pan.value == this.lastClickedAgentNumber) {
              copy = false;
            }
          } else if (
            this.lastClickedAgentNumber < this.previousClickedAgentNumber
          ) {
            if (pan.value == this.previousClickedAgentNumber) {
              copy = false;
            }
            if (pan.value == this.lastClickedAgentNumber) {
              copy = true;
            }
          }
        }

        this.agentNumberValues = this.shiftedAgentNumberValues;
      }

      this.previousAgentNumberValues = this.agentNumberValues;
      this.previousClickedAgentNumber = this.lastClickedAgentNumber;
    },
    allIndicator() {
      if (this.allIndicator == true) {
        this.agentNumberValues = [];
        this.previousAgentNumberValues = [];
        this.lastClickedAgentNumber = "";
        this.previousClickedAgentNumber = "";
      }
    },
    name() {
      this.errorMessages = "";
    },
    countryLocal() {
      if (
        this.previousCountry != null &&
        this.previousCountry != this.countryLocal &&
        this.previousCountry == "United States of America"
      ) {
        this.stateLocal = "";
      }

      this.previousCountry = this.countryLocal;
    }
    // statesOrProvinces() {
    //   if (!this.statesOrProvinces.find((sp) => sp == this.stateLocal)) {
    //     this.stateLocal = undefined;
    //   }
    // },
  },

  methods: {
    formatAgentNumber(y) {
      let x = y;
      x = x.replace(/^0+/, "");
      if (String(x).match(/^[0-9].*/)) {
        x = String(x).padStart(7, "0");
      }
      return x;
    },
    continueWithAll() {
      this.$modal.hide("verifyAllModal");
      this.submit(true);
    },
    onChangeRole() {
      if (
        this.user != null &&
        this.user.Role == null &&
        this.roleLocal == "Recruiting Director"
      ) {
        this.agencyLocal = [];
        this.$refs.agency.resetValidation();
        this.agencyLocal = [this.combinedAgencies.find(x => x == "ALL")];
        this.managerLocal = this.computedManagerNames.find(x => x);
      } else {
        if (this.roleLocal == "Recruiting Director") {
          this.agencyLocal = [];
          this.$refs.agency.resetValidation();
        } else {
          this.agencyLocal = "";
        }
      }
    },
    cancelChanges() {
      // EventBus.$emit("closeCreateUser");
      this.$router.push("/recruiting");
    },
    translateCountryToCode(countryName) {
      for (let country of this.allCountries) {
        if (country.CountryName == countryName) {
          return country.ISOCountryCode;
        }
      }

      return null;
    },
    translateCodeToCountry(code) {
      for (let country of this.allCountries) {
        if (country.ISOCountryCode == code) {
          return country.CountryName;
        }
      }
      return null;
    },

    getAgencies() {
      this.loading = true;
      HTTP_LND.get("GetAgenciesForAO", {
        params: {
          PrimaryAOAgentNumber: this.primaryAO.AgentNum
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.agencies = results.data;
          }
          this.loading = false;
          this.haveAgencies = true;
          if (
            this.haveAgencies == true &&
            this.havePartnershipAgencies == true &&
            this.haveManagers == true
          ) {
            this.waitCircle = false;
          }
        })
        .catch(e => {
          this.addToErrorLogs("create-edit-user.vue getAgencies", e);
          this.loading = false;
          this.$modal.show("errorModal");
        });
    },

    getPartnershipAgencies() {
      this.loading = true;
      HTTP_LND.get("GetPartnershipAgenciesForAO", {
        params: {
          PrimaryAOAgentNumber: this.primaryAO.AgentNum
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.partnershipAgencies = results.data;
          }
          this.loading = false;
          this.havePartnershipAgencies = true;
          if (
            this.haveAgencies == true &&
            this.havePartnershipAgencies == true &&
            this.haveManagers == true
          ) {
            this.waitCircle = false;
          }
        })
        .catch(e => {
          this.addToErrorLogs("create-edit-user.vue getPartnershipAgencies", e);
          this.loading = false;
          this.$modal.show("errorModal");
        });
    },

    getManagers() {
      this.loading = true;
      HTTP_LND.get("GetManagers", {
        params: {
          PrimaryAOAgentNumber: this.primaryAO.AgentNum
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.managers = results.data;
          }
          this.loading = false;
          this.haveManagers = true;
          if (
            this.haveAgencies == true &&
            this.havePartnershipAgencies == true &&
            this.haveManagers == true
          ) {
            this.waitCircle = false;
          }
        })
        .catch(e => {
          this.addToErrorLogs("create-edit-user.vue getManagers", e);
          this.loading = false;
          this.$modal.show("errorModal");
        });
    },

    async getCountries() {
      this.countries = [];
      this.waitCircle = true;

      HTTP_GAP.get("countries", {})
        .then(response => {
          if (response.status == 200) {
            for (let country of response.data) {
              this.countries.push(country.CountryName);

              if (
                this.user &&
                country.ISOCountryCode == this.user.ISOCountryCode
              ) {
                this.user.CountryName = country.CountryName;
              }

              this.allCountries.push(country);
            }

            if (this.user) {
              this.countryLocal = this.user.ISOCountryCode
                ? this.translateCodeToCountry(this.user.ISOCountryCode)
                : "United States of America";

              if (!this.countryLocal)
                this.countryLocal = "United States of America";
            } else {
              this.countryLocal = "United States of America";
            }
          } else {
            this.addToErrorLogs(
              "create-user.vue getCountries",
              new Error("response status is " + response.status.toString())
            );
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.addToErrorLogs("create-user.vue getCountries", e);
          this.$modal.show("errorModal");
        });

      this.countries.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
      });
      this.waitCircle = false;
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    async submit(useAll) {
      this.waitCircle = true;
      this.formHasErrors = false;

      let valid = true;

      Object.keys(this.form).forEach(f => {
        if (
          f == "state" &&
          this.countryLocal == "United States of America" &&
          !this.statesOrProvinces.find(sp => sp == this.form[f])
        ) {
          valid = false;
        }

        if (!this.form[f]) this.formHasErrors = true;

        if (!this.$refs[f].validate(true)) {
          if (f != "email" && this.isUpdate == true) {
            valid = false;
          } else if (this.isUpdate == false) {
            valid = false;
          }
        }
      });

      if (!valid) {
        this.waitCircle = false;
        return;
      }

      let updateRecruiterTable = false;
      if (valid && this.isUpdate) {
        let noChanges = false;

        if (
          this.firstNameLocal == this.user.FirstName &&
          this.middleNameLocal == this.user.MiddleName &&
          this.lastNameLocal == this.user.LastName &&
          this.addressLocal == this.user.AddressLine1 &&
          this.address2Local == this.user.AddressLine2 &&
          this.cityLocal == this.user.City &&
          this.stateLocal == this.user.StateProvinceCode &&
          this.zipLocal == this.user.PostalCode &&
          // this.translateCountryToCode(this.form.country) ==
          //   this.user.ISOCountryCode &&
          this.phoneLocal == this.user.PhoneNum &&
          this.emailLocal == this.user.Email &&
          this.ActivateSalesforceLicenseIndLocal ==
            this.user.ActivateSalesforceLicenseInd &&
          !this.disableUser &&
          !this.enableUser &&
          this.roleLocal == this.user.Role
        ) {
          noChanges = true;
        }
        if (noChanges == false) {
          updateRecruiterTable = true;
        }
        if (
          noChanges == true &&
          (!this.managerLocal.includes(this.user.Accesses[0].ManagerAgentNum) ||
            !this.managerLocal.includes(this.user.Accesses[0].ManagerRoleCode))
        ) {
          noChanges = false;
        }

        if (
          noChanges == false &&
          this.isUpdate == true &&
          this.user.Status == "F"
        ) {
          updateRecruiterTable = true;
        }

        let newAgencies = [];
        if (this.roleLocal == "Recruiting Director") {
          newAgencies.push(...this.agencyLocal);
        } else {
          newAgencies.push(this.agencyLocal);
        }

        if (
          noChanges == true &&
          newAgencies.length != this.user.Accesses.length
        ) {
          noChanges = false;
        } else if (noChanges == true) {
          newAgencies.forEach(element => {
            let found = false;
            this.user.Accesses.forEach(a => {
              if (element.startsWith(a.AgencyCode + " ")) {
                found = true;
              }
            });
            if (found == false) {
              noChanges = false;
            }
          });
        }

        if (noChanges == true) {
          this.waitCircle = false;
          this.$modal.show("noChangesModal");
          return;
        }

        if (
          noChanges == false &&
          this.enableUser == false &&
          this.user.RecruiterStatusCode == "I"
        ) {
          this.waitCircle = false;
          this.$modal.show("inactiveSaveModal");
          return;
        }
      }

      let curDate = new Date();

      if (valid) {
        let save = {};

        save.arrAccess = [];
        save.FederationID = this.isUpdate
          ? this.user.FederationID
          : this.form.email;
        save.FirstName = this.form.firstName;
        save.MiddleName = this.form.middleName;
        save.LastName = this.form.lastName;
        save.RecruiterStatusCode = this.isUpdate
          ? this.user.Status == "F" && this.disableUser
            ? "I"
            : this.user.Status == "F"
            ? "P"
            : this.enableUser
            ? "P"
            : this.disableUser
            ? "I"
            : this.user.Status
          : "P";
        save.OriginalRecruiterStatusCode = this.isUpdate
          ? this.user.Status
          : "";
        save.RoleName = this.form.role;
        save.RecruiterStatusMessageText = this.isUpdate
          ? this.user.Status == "F"
            ? null
            : this.disableUser || this.enableUser
            ? null
            : this.user.RecruiterStatusMessageText
          : null;
        // save.AssociatedAgentTMKClientID = window.sessionStorage.getItem(
        //   "tmkClientId"
        // );
        save.AssociatedAOAgentNum = this.primaryAO.AgentNum;
        save.AgentNum = "";
        save.AssociatedAOGLCompanyID = 4;
        save.AMTSourceMatchRecordInd = 1;
        save.TMKClientID = this.isUpdate
          ? this.user.Status == "F"
            ? null
            : this.user.TMKClientID
          : null;
        save.Email =
          this.form.email != null ? this.form.email : this.user.FederationID;
        save.AddressLine1 = this.form.address;
        save.AddressLine2 = this.form.address2;
        save.City = this.form.city;
        save.StateProvinceCode = this.form.state;
        save.PostalCode = this.form.zip;
        save.ISOCountryCode = this.translateCountryToCode(this.form.country);
        // save.ISOCountryCode = "US";
        save.PhoneNum = this.form.phone;
        save.EmploymentDate = this.isUpdate
          ? this.enableUser
            ? curDate.toISOString()
            : this.user.EmploymentDate
          : curDate.toISOString();
        save.TerminationDate = this.isUpdate
          ? this.disableUser
            ? curDate.toISOString()
            : this.user.TerminationDate
          : "2999-12-31T23:59:59Z";
        save.ActivateSalesforceLicenseInd = this.isUpdate
          ? this.ActivateSalesforceLicenseIndLocal
          : false;
        save.LastSalesforceLicenseActivatedDate = this.isUpdate
          ? this.user.LastSalesforceLicenseActivatedDate
          : null;
        save.CreatedBy = "AMT-" + window.sessionStorage.getItem("tmkClientId");
        save.CreatedDate = this.isUpdate
          ? this.user.CreatedDate
          : curDate.toISOString();
        save.UpdatedBy = "AMT-" + window.sessionStorage.getItem("tmkClientId");
        save.UpdatedDate = curDate.toISOString();
        save.UpdateRecruiterTable = updateRecruiterTable;
        let agencySave = [];
        if (this.roleLocal == "Recruiting Director") {
          if (this.agencyLocal.find(a => a == "ALL") != null) {
            agencySave.push("ALL");
            if (this.agencyLocal.length > 1 && !useAll) {
              this.waitCircle = false;
              this.$modal.show("verifyAllModal");
              return;
            }
          } else {
            this.agencyLocal.forEach(element => {
              agencySave.push(element);
            });
          }
        } else {
          agencySave.push(this.agencyLocal);
        }
        // cm.push(
        //   manager.LastName.trim() +
        //     ", " +
        //     manager.FirstName.trim() +
        //     (" " + manager.MiddleName).trim() +
        //     " (" +
        //     manager.AgentNum +
        //     " - " +
        //     manager.RoleCode +
        //     ")"
        // );
        let managerArray = this.managerLocal.split("(")[1].split("-");
        agencySave.forEach(agency => {
          let element = {
            FederationID: save.FederationID,
            AssociatedAOGLCompanyID: save.AssociatedAOGLCompanyID,
            AssociatedAOAgentNum: save.AssociatedAOAgentNum,
            AMTSourceMatchRecordInd: save.AMTSourceMatchRecordInd,
            AgencyCode: agency.split(" ")[0].trim(),
            GLCompanyID: 4,
            ManagerAgentNum: /^\d.*/.test(managerArray[0].trim())
              ? String(managerArray[0].trim()).padStart(7, "0")
              : managerArray[0].trim(),
            ManagerRoleCode: managerArray[1].replace(")", "").trim(),
            StartDate: new Date().toISOString(),
            EndDate: "2999-12-31T23:59:59Z",
            CreatedBy: save.CreatedBy,
            CreatedDate: save.CreatedDate,
            UpdatedBy: save.UpdatedBy,
            UpdatedDate: save.UpdatedDate
          };
          save.arrAccess.push(element);
        });

        if (this.isUpdate) {
          if (
            (this.user.Status == "I" || this.user.Status == "F") &&
            save.RecruiterStatusCode == "P"
          ) {
            HTTP_LND.post("CheckForActive", { federationId: save.FederationID })
              .then(results => {
                if (results.status == 200) {
                  if (results.data != null && results.data.length > 0) {
                    this.waitCircle = false;
                    this.$modal.show("userExistsModal");
                  } else {
                    HTTP_LND.post("UpdateRecruiter", save)
                      .then(results => {
                        if (results.status == 200) {
                          if (this.disableUser == true) {
                            HTTP_LND.post("disable", {
                              federationId: save.FederationID,
                              primaryAONum: save.AssociatedAOAgentNum,
                              revokeFlag: true,
                              updatedBy: save.UpdatedBy
                            })
                              .then(ret => {
                                if (
                                  ret.status == 200 &&
                                  ret.data.body == '"Invalid User"'
                                ) {
                                  this.waitCircle = false;
                                  this.$modal.show("notInAdldsModal");
                                } else if (
                                  ret.status == 200 &&
                                  ret.data.body != '"InActive"'
                                ) {
                                  this.waitCircle = false;
                                  this.$modal.show("errorAdldsModal");
                                } else if (ret.status == 200) {
                                  this.waitCircle = false;
                                  this.$modal.show("saveModal");
                                } else {
                                  this.waitCircle = false;
                                  this.$modal.show("errorModal");
                                }
                              })
                              .catch(e => {
                                this.waitCircle = false;
                                this.$modal.show("errorModal");
                                this.addToErrorLogs(
                                  "create-user.vue submit Disable",
                                  e
                                );
                              });
                          } else {
                            this.waitCircle = false;
                            this.$modal.show("saveModal");
                          }
                        } else {
                          this.waitCircle = false;
                          this.$modal.show("errorModal");
                        }
                      })
                      .catch(e => {
                        this.waitCircle = false;
                        this.$modal.show("errorModal");
                        this.addToErrorLogs(
                          "create-user.vue submit UpdateRecruiter 1",
                          e
                        );
                      });
                  }
                }
              })
              .catch(e => {
                this.addToErrorLogs(
                  "create-edit-user.vue submit CheckForActive",
                  e
                );
                this.waitCircle = false;
                this.$modal.show("errorModal");
              });
          } else {
            HTTP_LND.post("UpdateRecruiter", save)
              .then(results => {
                if (results.status == 200) {
                  if (this.disableUser == true) {
                    HTTP_LND.post("disable", {
                      federationId: save.FederationID,
                      primaryAONum: save.AssociatedAOAgentNum,
                      revokeFlag: true,
                      updatedBy: save.UpdatedBy
                    })
                      .then(ret => {
                        if (
                          ret.status == 200 &&
                          ret.data.body == '"Invalid User"'
                        ) {
                          this.waitCircle = false;
                          this.$modal.show("notInAdldsModal");
                        } else if (
                          ret.status == 200 &&
                          ret.data.body != '"InActive"'
                        ) {
                          this.waitCircle = false;
                          this.$modal.show("errorAdldsModal");
                        } else if (ret.status == 200) {
                          this.waitCircle = false;
                          this.$modal.show("saveModal");
                        } else {
                          this.waitCircle = false;
                          this.$modal.show("errorModal");
                        }
                      })
                      .catch(e => {
                        this.waitCircle = false;
                        this.$modal.show("errorModal");
                        this.addToErrorLogs(
                          "create-user.vue submit Disable",
                          e
                        );
                      });
                  } else {
                    this.waitCircle = false;
                    this.$modal.show("saveModal");
                  }
                } else {
                  this.waitCircle = false;
                  this.$modal.show("errorModal");
                }
              })
              .catch(e => {
                this.waitCircle = false;
                this.$modal.show("errorModal");
                this.addToErrorLogs(
                  "create-user.vue submit UpdateRecruiter 1",
                  e
                );
              });
          }
        } else {
          let checkForExistingParams = {
            PrimaryAOAgentNumber: save.AssociatedAOAgentNum,
            FederationId: save.FederationID
          };
          HTTP_LND.post("CheckForExisting", checkForExistingParams)
            .then(results => {
              if (results.status == 200) {
                if (results.data != null && results.data.length > 0) {
                  if (
                    results.data[0].AssociatedAOAgentNum ==
                    save.AssociatedAOAgentNum
                  ) {
                    this.waitCircle = false;
                    this.$modal.show("userExistsForAOModal");
                  } else {
                    this.waitCircle = false;
                    this.$modal.show("userExistsForOtherAOModal");
                  }
                  return;
                } else {
                  HTTP_LND.get("adlds", {
                    params: {
                      federationId: save.FederationID
                    }
                  })
                    .then(results => {
                      if (results.status == 200) {
                        this.adldsStatus = results.data;
                        if (
                          results.data == "Invalid User" ||
                          results.data.toLowerCase() == "inactive"
                        ) {
                          HTTP_LND.post("CreateAgent", save)
                            .then(results => {
                              if (results.status == 200) {
                                this.waitCircle = false;
                                this.$modal.show("saveModal");
                              } else {
                                this.waitCircle = false;
                                this.$modal.show("errorModal");
                              }
                            })
                            .catch(e => {
                              this.waitCircle = false;
                              this.$modal.show("errorModal");
                              this.addToErrorLogs(
                                "create-user.vue submit CreateAgent 1",
                                e
                              );
                            });
                        } else {
                          this.waitCircle = false;
                          this.$modal.show("userExistsInAdldsModal");
                          return;
                        }
                      }
                    })
                    .catch(e => {
                      this.addToErrorLogs(
                        "create-edit-user.vue submit adlds",
                        e
                      );
                      this.waitCircle = false;
                      this.$modal.show("errorModal");
                    });
                }
              }
            })
            .catch(e => {
              this.addToErrorLogs(
                "create-edit-user.vue submit CheckForExisting",
                e
              );
              this.waitCircle = false;
              this.$modal.show("errorModal");
            });
        }

        // if (save.AgentAdminStatusCode == "P") {
        //   HTTP_GAP.post("CheckInactiveDups", save)
        //     .then((results) => {
        //       if (results.status == 200) {
        //         let admins = results.data;
        //         let OK = true;

        //         if (admins && admins.length && !this.isUpdate) {
        //           OK = false;
        //           this.waitCircle = false;
        //           this.$modal.show("insertDupErrorModal");
        //           return;
        //         }

        //         if (OK) {
        //           HTTP_GAP.post("CheckDups", save)
        //             .then((results) => {
        //               if (results.status == 200) {
        //                 let agents = results.data;
        //                 let OK = true;

        //                 if (agents && agents.length) {
        //                   if (!this.isUpdate) {
        //                     OK = false;
        //                     this.waitCircle = false;
        //                     this.$modal.show("insertUpdateErrorModal");
        //                     return;
        //                   } else {
        //                     for (let agent of agents) {
        //                       if (
        //                         agent.AssociatedAgentTMKClientID !=
        //                         save.AssociatedAgentTMKClientID
        //                       ) {
        //                         OK = false;
        //                         this.waitCircle = false;
        //                         this.$modal.show("insertUpdateErrorModal");
        //                         return;
        //                       }
        //                     }
        //                   }
        //                 }

        //                 if (OK && !this.isUpdate) {

        //                 } else if (OK && this.isUpdate) {
        //                   HTTP_GAP.post("UpdateAgentAdmin", save)
        //                     .then((results) => {
        //                       if (results.status == 200) {
        //                         this.waitCircle = false;
        //                         this.$modal.show("saveModal");
        //                       } else {
        //                         this.waitCircle = false;
        //                         this.$modal.show("errorModal");
        //                       }
        //                     })
        //                     .catch((e) => {
        //                       this.waitCircle = false;
        //                       this.$modal.show("errorModal");
        //                       this.addToErrorLogs(
        //                         "create-user.vue submit UpdateAgentAdmin 1",
        //                         e
        //                       );
        //                     });
        //                 }
        //               } else {
        //                 this.waitCircle = false;
        //                 this.$modal.show("errorModal");
        //               }
        //             })
        //             .catch((e) => {
        //               this.waitCircle = false;
        //               this.$modal.show("errorModal");
        //               this.addToErrorLogs(
        //                 "create-user.vue submit CheckDups",
        //                 e
        //               );
        //             });
        //         }
        //       } else {
        //         this.waitCircle = false;
        //         this.$modal.show("errorModal");
        //       }
        //     })
        //     .catch((e) => {
        //       this.waitCircle = false;
        //       this.$modal.show("errorModal");
        //       this.addToErrorLogs(
        //         "create-user.vue submit CheckInactiveDups",
        //         e
        //       );
        //     });
        // } else {
        //   HTTP_GAP.post("UpdateAgentAdmin", save)
        //     .then((results) => {
        //       if (results.status == 200) {
        //         if (this.disableUser) {
        //           HTTP_GAP.get("disableUser", {
        //             params: { userName: this.form.email },
        //           })
        //             .then((results) => {
        //               if (results.status == 200) {
        //                 this.waitCircle = false;
        //                 this.$modal.show("saveModal");
        //               } else {
        //                 this.waitCircle = false;
        //                 this.$modal.show("cognitoErrorModal");
        //               }
        //             })
        //             .catch((e) => {
        //               this.waitCircle = false;
        //               this.$modal.show("cognitoErrorModal");
        //               this.addToErrorLogs(
        //                 "create-user.vue submit disableUser",
        //                 e
        //               );
        //             });
        //         } else {
        //           this.waitCircle = false;
        //           this.$modal.show("saveModal");
        //         }
        //       } else {
        //         this.waitCircle = false;
        //         this.$modal.show("errorModal");
        //       }
        //     })
        //     .catch((e) => {
        //       this.waitCircle = false;
        //       this.$modal.show("errorModal");
        //       this.addToErrorLogs(
        //         "create-user.vue submit UpdateAgentAdmin 2",
        //         e
        //       );
        //     });
        // }
      }
    }
  }
};
</script>

<style scoped>
.drop {
  margin-top: 100px;
}
.littleDrop {
  margin-top: 15px;
}

.addressTitle {
  color: green;
  font-size: 2rem;
  font-weight: normal;
  margin-left: 20px;
  padding-top: 20px;
}
.addressTitleXS {
  color: green;
  font-size: 1.5rem;
  font-weight: normal;
  margin-left: 20px;
  padding-top: 20px;
}
.addressTitle2 {
  color: #00558c;
  font-size: 1.25rem;
  font-weight: bold;
  margin-left: 70px;
  padding-top: 20px;
}
.addressTitleXS2 {
  color: #00558c;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 70px;
  padding-top: 20px;
}
.removeTopAndBottomPadding {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.waitCircle {
  z-index: 20;
  position: absolute;
  top: 50%;
  left: 48%;
}
</style>
